<!-- shopy Head -->
<div class="loader_session" *ngIf="loaderdata">
  <div class="loader-4"><span></span></div>
</div>
<div
  class="collecting-header"
  style="background-image: url(assets/image/Group-1895.png)"
>
  <div class="collecting-head">
    <div class="head">
      <h3>MISSION STATEMENT</h3>
    </div>
  </div>
</div>

<div class="container my-5">
  <div class="page-header">
    <h1 class="page-title page-main-title" itemprop="headline">
      Antique Phonograph Society Mission Statement
    </h1>
  </div>

  <p class="lead">
    The Antique Phonograph Society is a nonprofit corporation formed under the
    laws of State of Washington to provide charitable programs including, but
    not limited to:
  </p>
  <p>
    (a) Conducting research with respect to the preservation of recorded sound
    and providing scholarly information, services and entertainment to persons
    interested in collecting and preserving antique phonographs and other
    mechanical music-making devices, including but not limited to cylinder and
    disc records;
  </p>
  <p>
    (b) Encouraging newcomers to follow museum-quality preservation and
    authentic restoration standards when restoring these items; and
  </p>
  <p>
    (c) Educating the public regarding the history and care of these machines
    and records so that future generations may learn and enjoy this early form
    of recorded sound.
  </p>
  <p>&nbsp;</p>
  <p>
    The Antique Phonograph Society is governed by a Board of Directors, who
    elects the officers of the Society on an annual basis. APS also has a Board
    of Advisors in place, to oversee the Board of Directors.
  </p>
  <p>
    The Antique Phonograph Society
    <a
      href="https://apsblobdeve.blob.core.windows.net/aps-website-files/APS-CertificateofIncorporation.pdf"
      target="_blank"
      >Certificate of Incorporation</a
    >,
    <a
      href="https://apsblobdeve.blob.core.windows.net/aps-website-files/APS-ArticlesOfIncorporation.pdf"
      target="_blank"
      >Articles of Incorporation</a
    >
    and
    <a
      href="https://apsblobdeve.blob.core.windows.net/aps-website-files/APS-Bylaws.pdf"
      target="_blank"
      >Bylaws</a
    >
    are available at any time upon reasonable request. They may also be viewed
    by clicking on these links.
  </p>
  <p>
    In August, 2014, the Antique Phonograph Society filed an Application for
    Recognition of Exemption under Section 501(c)(3) of the Internal Revenue
    Code. The IRS application was approved 04 September 2014 and the approval
    letter may be viewed via the associated link.
    <a
      href="https://apsblobdeve.blob.core.windows.net/aps-website-files/APS-IRSExemptionLetter.pdf"
      target="_blank"
      >IRS Exemption Letter</a
    >
  </p>
</div>
